<template>
	<div>
		<v-row>
			<v-col cols="12" md="12" class="d-flex flex-wrap">
				<v-chip class="" color="secondary" outlined style="cursor: pointer;" @click="editMember">
					<v-icon left>
						mdi-account-outline
					</v-icon>
					{{ data.member.fullName }}
					(&lrm;{{ data.member.userName }})
				</v-chip>
				<v-chip class="mx-2" color="secondary" outlined>
					<v-icon left small>
						mdi-cellphone
					</v-icon>
					موبایل: {{ data.member.mobile }}
				</v-chip>
				<v-chip class="" color="secondary" outlined>
					وضعیت خوش حسابی:
					<ReliabilityManager :member="data.member" style="cursor:pointer" />
				</v-chip>
			</v-col>
		</v-row>
		<v-divider class="my-3" />
		<div>
			<v-tabs v-model="activeTab" @change="tabChanged" :class="{ 'hide': selectedUserLoan2 }" centered color="secondary" slider-color="secondary">
				<v-tab :value="0" class="can-hide">پرونده وام ها</v-tab>
				<v-tab :value="1" style="width:10px;display: none;"></v-tab>
				<v-tab :value="2" class="can-hide">درخواست وام ها</v-tab>
				<v-tab :value="3" class="can-hide">تراکنش ها</v-tab>
				<v-tab :value="4" class="can-hide">پیامک ها</v-tab>
				<v-tab :value="5" class="can-hide">تیکت ها</v-tab>
				<v-tab :value="6" class="can-hide">تضامین</v-tab>
				<v-tabs-items v-model="activeTab" touchless class="mt-6">
					<v-tab-item :key="0">
						<v-row v-if="loans && loans.length > 2">
							<v-col cols="12" md="12" class="text-center">
								<v-btn class="mx-auto" color="secondary" dark @click="add">
									<v-icon dark>
										mdi-plus-circle-outline
									</v-icon>
									افزودن وام
								</v-btn>
							</v-col>
						</v-row>
						<v-row v-if="loading">
							<v-col cols="12">
								<div class="success--text text-h4 text-center">
									در حال دریافت اطلاعات ...
								</div>
							</v-col>
						</v-row>
						<v-row v-else-if="!loans || loans.length == 0">
							<v-col cols="12">
								<div class="red--text text-h4 text-center">
									تاکنون وامی برای این شخص ثبت نشده است.
								</div>
							</v-col>
						</v-row>
						<v-row v-else class="loan-cards">
							<v-col v-for="l in loans" :key="l.id" cols="12" md="12">
								<ManageLoanItem :data="l" @showInstallments="showInstallments(l)" @loadData="loadData" />
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="12" class="text-center">
								<v-btn v-if="!loading" class="mx-auto" color="secondary" dark @click="add">
									<v-icon dark>
										mdi-plus-circle-outline
									</v-icon>
									افزودن وام
								</v-btn>
							</v-col>
						</v-row>
					</v-tab-item>
					<v-tab-item :key="1">
						<v-row class="justify-center mb-2" v-if="selectedUserLoan2 != null">
							<v-col cols="12" md="6">
								<v-card class="pa-3" color="#eee" elevation="0">
									<div style="text-align:center" class="secondary--text">
										<v-row>
											<v-col cols="4" md="4">
												{{ selectedUserLoan2.loanModel.title }}<br /> {{ selectedUserLoan2.amount.toString().toPriceFormat() }}
												تومان
											</v-col>
											<v-col cols="4" md="4">
												شروع: <br />{{ selectedUserLoan2.startDate_Persian.date }}
											</v-col>
											<v-col cols="4" md="4">
												هر قسط: <br />{{ selectedUserLoan2.installment.toString().toPriceFormat() }} تومان
											</v-col>
										</v-row>
									</div>
								</v-card>
							</v-col>
						</v-row>
						<loan-installments ref="installments" v-if="activeTab == 1" :data="{ userloan: selectedUserLoan2, adminPanel: true }" @changed="getDataById" @back="loanInstallmentsBack" />
					</v-tab-item>
					<v-tab-item :key="2">
						<v-data-table :loading="loanRequestLoading" :headers="headers" :items="loanRequestItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" class="elevation-1">
							<template v-slot:item="row">
								<tr>
									<td>
										<div class="info--text" style="cursor:pointer" @click="editLoanRequest(row.item)">
											<span class="text-small info--grey">شماره درخواست:</span> {{ row.item.code }}
										</div>
										<div class="">
											<small class="text-small info--grey">مبلغ: {{ row.item.amount.toString().toPriceFormat() }}</small>
										</div>
										<div class="">
											<small class="text-small info--grey">تاریخ: &lrm;{{ `${row.item.requestDate_Persian.date} ${row.item.requestDate_Persian.time}` }}</small>
										</div>
										<div><small>{{ row.item.loanModel.title }}</small></div>
									</td>
									<td class="text-center">
										{{ row.item.str_Status }}
									</td>
									<td>
										<div @click="editAgent({ id: row.item.agentModel.id })" style="cursor:pointer">
											{{ row.item.agentModel ? row.item.agentModel.businessName : '' }}
										</div>
										{{ row.item.memberModel && row.item.memberModel.marketerName ? row.item.memberModel.marketerName : '' }}
									</td>
									<td class="text-center">
										{{ row.item.agentModel ? row.item.str_AgentStatus : '' }}
									</td>
									<td>
										{{ row.item.adminDescriptionPrivate || "-" }}
									</td>
									<td class="text-center">
										<v-btn class="mx-1" fab dark small color="secondary" @click="editLoanRequest(row.item)">
											<v-icon dark>
												mdi-square-edit-outline
											</v-icon>
										</v-btn>
										<v-btn class="mx-1" fab dark small color="pink" @click="removeLoanRequest(row.item)">
											<v-icon dark>
												mdi-trash-can-outline
											</v-icon>
										</v-btn>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-tab-item>
					<v-tab-item :key="3">
						<v-card color="white" class="pa-3">
							<online-gateway-payments ref="onlineGatewayPayments" :data="{ memberId: data.member.id }" :autoLoad="false" />
						</v-card>
					</v-tab-item>
					<v-tab-item :key="4">
						<v-card color="white" class="pa-3">
							<sms-list ref="smsList" :mobile="data.member.mobile" :autoLoad="false" area="admin" />
						</v-card>
					</v-tab-item>
					<v-tab-item :key="5">
						<v-card color="white" class="pa-3">
							<Tickets ref="tickets" :memberId="data.member.id" userType="admin" />
						</v-card>
					</v-tab-item>
					<v-tab-item :key="6">
						<v-card color="white" class="pa-3">
							<Assurances ref="assurances" :memberId="data.member.id" :hideDateRange="true" />
						</v-card>
					</v-tab-item>
				</v-tabs-items>
			</v-tabs>
		</div>

		<v-dialog v-model="dialogMember" scrollable persistent max-width="900px">
			<modify-member :data="selectedMember" v-if="dialogMember" @callbck="callbckMember" @close="dialogMember = false" />
		</v-dialog>

		<v-dialog v-model="dialogLoanRequest" scrollable persistent max-width="1100px">
			<modify-request ref="modifyRequest" v-if="dialogLoanRequest" :data="selectedRequest" @callbck="callbck_loanRequest" @close="dialogLoanRequest = false" />
		</v-dialog>

		<v-dialog v-model="dialogAgent" scrollable persistent max-width="700px">
			<v-card>
				<v-card-title>
					<span class="headline">مشخصات نماینده</span>
					<v-spacer />
					<v-btn @click="dialogAgent = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<ModifyAgent :data="selectedAgent" v-if="dialogAgent" @callbck="agent_callbck" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogModifyUserLoan" scrollable persistent max-width="600px">
			<v-card>
				<v-card-title>
					<div><span class="headline">ثبت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogModifyUserLoan = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-user-loan ref="modifyUserLoan" v-if="dialogModifyUserLoan" :data="selectedUserLoan" @callbck="callbck_userLoan" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<app-sms-detail ref="appSmsDetail" :entityId="selectedUserLoan ? selectedUserLoan.id : ''" :data="selectedUserLoan ? selectedUserLoan.appSmsList : []" :hideTypesBadge="true" type="NewUserLoan" />

		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import { cloneDeep } from 'lodash'
	import { get } from 'vuex-pathify'

	export default {
		name: 'ManageLoanView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			ModifyAgent: () => import('@/views/admin/agent/ModifyAgent'),
			'loan-installments': () => import('./LoanInstallments.vue'),
			'ReliabilityManager': () => import('@/components/ReliabilityManager.vue'),
			'ManageLoanItem': () => import('@/components/forms/ManageLoanItem.vue'),
			'sms-list': () => import('@/views/admin/SMSList.vue'),
			'online-gateway-payments': () => import('@/views/admin/Report/OnlineGatewayPayments.vue'),
			'modify-member': () => import('@/views/admin/ModifyMember'),
			'modify-request': () => import('./ModifyLoanRequest.vue'),
			'modify-user-loan': () => import('./ModifyUserLoan.vue'),
			'Tickets': () => import('@/components/ticket/AdminTickets.vue'),
			'Assurances': () => import('@/views/admin/Report/Assurances.vue'),
			'app-sms-detail': () => import('@/components/AppSmsDetails.vue'),
		},
		props: {
			data: { type: Object },
			area: { type: String, default: 'admin' }
		},
		data() {
			return {
				selectedAgent: {},
				activeTab: 0,
				loading: false,
				loanRequestLoading: false,
				errorMessages: '',
				selectedMember: {},
				dialogMember: false,
				dialogLoanRequest: false,
				dialogThirdParty: false,
				dialogAgent: false,
				dialogModifyUserLoan: false,
				selectedUserLoan: null,
				selectedUserLoan2: null,
				loans: [],
				loanRequestItems: [],
				selectedRequest: null,
				headers: [
					{
						text: 'اطلاعات درخواست',
						align: 'start',
						sortable: true,
						value: 'code',
						width: 170
					},
					{
						text: 'وام',
						align: 'start d-none',
						sortable: true,
						value: 'loanModel.title',
					},
					{
						text: 'مبلغ',
						align: 'center d-none',
						sortable: true,
						value: 'amount',
					},
					{
						text: 'تاریخ ثبت درخواست',
						align: 'center d-none',
						sortable: true,
						value: 'requestDate_Persian',
					},
					{
						text: 'وضعیت',
						align: 'center',
						sortable: true,
						value: 'str_Status',
					},
					{
						text: 'نماینده/بازاریاب',
						align: 'center',
						sortable: true,
						value: 'agentModel.businessName',
					},
					{
						text: 'نماینده/بازاریاب',
						align: 'center d-none',
						sortable: true,
						value: 'memberModel.marketerName',
					},
					{
						text: 'وضعیت نماینده',
						align: 'center',
						sortable: true,
						value: 'str_AgentStatus',
					},
					{
						text: 'نظر کارشناس',
						align: 'start',
						sortable: true,
						value: 'adminDescription',
					},
					{
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						width: 150,
					},
				],
			}
		},
		computed: {
			...get('auth', [
				'getCurrentUser',
			]),
			customerName() {
				var user = this.getCurrentUser
				if (user && user.userData && user.userData.customer) { return `${user.userData.customer.name}` }
				return ''
			},
		},
		mounted() {
			this.loadData()
		},
		methods: {
			add() {
				this.selectedUserLoan = { id: emptyId, memberModel: this.data.member }
				this.dialogModifyUserLoan = true
			},
			loadData() {
				this.activeTab = 0
				this.loading = true
				api.get('admin/userloan/GetLoansByUserId/' + this.data.member.id, null)
					.then(
						response => {
							this.loans = response
						})
					.catch(err => {
						toast.error(err.message)
					}).finally(x => {
						this.loading = false
					})
			},
			getDataById(id) {
				api.get('admin/userloan/get/' + id, null)
					.then(
						response => {
							let index = this.loans.findIndex(x => x.id == id)
							if (index > -1)
								this.loans[index] = response
							this.selectedUserLoan2 = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			showInstallments(userLoan) {
				this.selectedUserLoan2 = userLoan
				this.activeTab = 1
			},
			callbck_userLoan(result) {
				this.dialogModifyUserLoan = false
				if (result) { this.loadData() }
			},
			loanInstallmentsBack() {
				this.activeTab = 0
				this.selectedUserLoan2 = null
			},
			editMember(item) {
				this.selectedMember = this.data.member
				this.dialogMember = true
			},
			callbckMember(result) {
				this.dialogMember = false
			},
			tabChanged(tab) {
				if (tab == 2)
					this.loadDataLoanRequest(true)
			},
			loadDataLoanRequest() {
				this.loanRequestLoading = true
				api.get('admin/userLoanRequest/list?memberId=' + this.data.member.id, null)
					.then(response => {
						this.loanRequestItems = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loanRequestLoading = false
					})
			},
			editLoanRequest(item) {
				this.dialogLoanRequest = true
				this.selectedRequest = item
			},
			callbck_loanRequest(result) {
				// this.dialog = false
				if (result) {
					this.loadDataLoanRequest()
				}
			},
			async removeLoanRequest(item) {
				if (!item) {
					return
				}

				if (
					await this.$refs.confirm.open(
						'توجه',
						'آیا از حذف این آیتم مطمئن هستید؟',
					)
				) {
					api
						.post('admin/userLoanRequest/delete/' + item.id)
						.then(response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.loadDataLoanRequest()
						})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			editAgent(agent) {
				if (!agent?.id)
					return
				this.selectedAgent = agent
				this.dialogAgent = true
			},
			agent_callbck(result) {
				this.dialogAgent = false
			},
		},
	}
</script>
<style>

	.v-tabs.hide .v-tabs-bar,
	.v-tabs.hide .can-hide,
	.v-tabs.hide .v-tabs-slider-wrapper {
		display: none !important;
		height: 0px;
	}

	.v-tabs.hide .v-tabs-bar {
		display: none !important;
		height: 0px;
	}
</style>
